import { AiOutlineFileAdd } from "react-icons/ai"
import UploadFileDrawer from "../../../common/UploadFileDrawer"
import useDisclosure from "../../../../hooks/useDisclosure"
import { colors } from "../../../../utilities/colors"

export default function FilesTableHeader ({ dealerId, modalTitle, fileType }) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return(
    <>
      <div className="hover:cursor-pointer">
        <AiOutlineFileAdd
          onClick={onOpen}
          size={'30px'}
          data-testid='open-modal'
          color={colors.white}
        />
      </div>
      <UploadFileDrawer
        isOpen={isOpen}
        onClose={onClose}
        dealerId={dealerId}
        fileType={fileType}
        modalTitle={modalTitle}
      />
    </>
  )
}